import { useContext } from 'react';
import { GlobalState } from "./../../context/globalState";

const Packed = ({ logo, packageName, packageAmount, commission, packagePrice }) => {
  const { Helper } = useContext(GlobalState);

  return (
    <div style={{ background: '#fff', padding: 10, borderRadius: 16, display: 'grid', gap: 10 }}>
      <div style={{ display: 'grid', gap: 10 }}>
        <div style={{ display: 'flex', gap: 10 }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
              <img style={{ width: 42, objectFit: 'cover' }} src={logo} alt="logo" />
              <b style={{ fontSize: 16, color:'#343A40' }}>{packageName}</b>
            </div>
          </div>
        </div>
        <div style={{ width: '100%', height: '0.5px', background: '#d2d2d2' }}></div>
        <div className="info-row gray">
          <div style={{fontSize: 14}}>Phí bảo hiểm/người/năm:</div>
          <div className="success" style={{ color: '#FB7800' }}>{Helper.formatMoney(packagePrice)} VNĐ</div>
        </div>
        {
          Helper.getParamUrlByKey('platform') === 'app' &&
          <div className="info-row">
            <div style={{ color: '#646D69', fontSize: 14}}>Lương doanh thu:</div>
            <div style={{ color: '#343A40' }} className="highlight">{Helper.formatMoney(commission)} VNĐ</div>
          </div>
        }
        <div className="info-row">
          <div style={{ color: '#646D69', fontSize: 14}}>Thời hạn bảo hiểm:</div>
          <div style={{ color: '#343A40' }} className="highlight">1 năm</div>
        </div>
      </div>
    </div>
  );
}

export default Packed;